import { render, staticRenderFns } from "./ModalDigest.vue?vue&type=template&id=5d54776e&scoped=true"
import script from "./ModalDigest.vue?vue&type=script&lang=js"
export * from "./ModalDigest.vue?vue&type=script&lang=js"
import style0 from "./ModalDigest.vue?vue&type=style&index=0&id=5d54776e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d54776e",
  null
  
)

export default component.exports